import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link, NavLink, useLocation, useNavigate  } from "react-router-dom";
import ThemeToggleButton from "../helper/ThemeToggleButton";
import webLogo from "../otherImages/logo-icon.png"
import webSideLogo from "../otherImages/logo-side.png"
import profilePic from "../otherImages/profilePic.png"
import localStoreUtil from "../Redux/Utils/localStore";
import Swal from "sweetalert2";

const MasterLayout = ({ children }) => {
  const [sidebarActive, setSidebarActive] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);
  const location = useLocation();
    const navigate = useNavigate();

  const handleLogout = async () => {
      localStoreUtil.removeAll();
      navigate("/", { replace: true });
  };

  useEffect(() => {
    const openActiveDropdown = () => {
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        const submenuLinks = dropdown.querySelectorAll(".sidebar-submenu li a");
        submenuLinks.forEach((link) => {
          if (
            link.getAttribute("href") === location.pathname ||
            link.getAttribute("to") === location.pathname
          ) {
            dropdown.classList.add("open");
            const submenu = dropdown.querySelector(".sidebar-submenu");
            if (submenu) {
              submenu.style.maxHeight = `${submenu.scrollHeight}px`;
            }
          }
        });
      });
    };

    openActiveDropdown();
  }, [location.pathname]);

  const sidebarControl = () => setSidebarActive(!sidebarActive);
  const mobileMenuControl = () => setMobileMenu(!mobileMenu);

  return (
    <section className={mobileMenu ? "overlay active" : "overlay "}>
      {/* sidebar */}
      <aside
        className={
          sidebarActive
            ? "sidebar active "
            : mobileMenu
            ? "sidebar sidebar-open"
            : "sidebar"
        }
      >
        <button
          onClick={mobileMenuControl}
          type='button'
          className='sidebar-close-btn'
        >
          <Icon icon='radix-icons:cross-2' />
        </button>
        <div>
          <Link to='/' className='sidebar-logo'>
            <img
              src={webLogo}
              alt='site logo'
              className='light-logo'
            />
            <img
              src={webLogo}
              alt='site logo'
              className='dark-logo'
              style={{filter:"brightness(100)",}}
            />
            <img
              src={webSideLogo}
              alt='site logo'
              className='logo-icon'
              style={{width:"40px",}}
            />
          </Link>
        </div>
        <div className='sidebar-menu-area'>
          <ul className='sidebar-menu' id='sidebar-menu'>
            <>
              <li>
                <NavLink to='/dashboard' 
                className={(navData) =>
                  navData.isActive ? "active-page" : ""
                }
                >
                  <Icon
                    icon='hugeicons:dashboard-square-01'
                    className='menu-icon'
                    width="23"
                  />
                  <span>Dashboard</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to='/users'
                  className={(navData) => (navData.isActive ? "active-page" : "")}
                >
                  <Icon icon='mdi:account-group' className='menu-icon'width="25" height="25" />
                  <span>Users</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to='/statistics'
                  className={(navData) => (navData.isActive ? "active-page" : "")}
                >
                  <Icon icon='mdi:analytics' className='menu-icon' width="28" height="28" />
                  <span>Statistics</span>
                </NavLink>
              </li>   
              <li>
                <NavLink
                  to='/inactive-users'
                  className={(navData) => (navData.isActive ? "active-page" : "")}
                >
                  <Icon icon='solar:user-block-bold' className='menu-icon' width="28" height="28" />
                  <span>Inactive Users</span>
                </NavLink>
              </li>    
              <li>
                <NavLink
                  to='/transactions'
                  className={(navData) => (navData.isActive ? "active-page" : "")}
                >
                  <Icon icon='ic:baseline-currency-exchange' className='menu-icon' width="23" height="23" style={{marginRight:"10px",}} />
                  <span>Transactions</span>
                </NavLink>
              </li>  
              <li>
                <NavLink
                  to='/coupons'
                  className={(navData) => (navData.isActive ? "active-page" : "")}
                >
                  <Icon icon='solar:ticket-bold' className='menu-icon' width="23" height="23" style={{marginRight:"10px",}} />
                  <span>Coupon Code</span>
                </NavLink>
              </li>      
            </>
          </ul>
        </div>
        <div className="bottomSide">
              <ul>
                <li>
                 <NavLink
                  to='/'
                  onClick={handleLogout}
                >
                  <Icon icon='material-symbols:logout-rounded' className='menu-icon' width="28" height="28" />
                  <span>Log Out</span>
                </NavLink>
                </li>
              </ul>
        </div>
      </aside>

      <main
        className={sidebarActive ? "dashboard-main active" : "dashboard-main"}
      >
        <div className='navbar-header'>
          <div className='row align-items-center justify-content-between'>
            <div className='col-auto'>
              <div className='d-flex flex-wrap align-items-center gap-4'>
                <button
                  type='button'
                  className='sidebar-toggle'
                  onClick={sidebarControl}
                >
                  {sidebarActive ? (
                    <Icon
                      icon='iconoir:arrow-right'
                      className='icon text-2xl non-active'
                    />
                  ) : (
                    <Icon
                      icon='heroicons:bars-3-solid'
                      className='icon text-2xl non-active '
                    />
                  )}
                </button>
                <button
                  onClick={mobileMenuControl}
                  type='button'
                  className='sidebar-mobile-toggle'
                >
                  <Icon icon='heroicons:bars-3-solid' className='icon' />
                </button>
                {/* <form className='navbar-search'>
                  <input type='text' name='search' placeholder='Search' />
                  <Icon icon='ion:search-outline' className='icon' />
                </form> */}
              </div>
            </div>
            <div className='col-auto'>
              <div className='d-flex flex-wrap align-items-center gap-3'>
                {/* ThemeToggleButton */}
                {/* <ThemeToggleButton /> */}

                {/* Notification dropdown end */}
                <div className='dropdown'>
                  <button
                    className='d-flex justify-content-center align-items-center rounded-circle'
                    type='button'
                    data-bs-toggle='dropdown'
                  >
                    <img
                      src={profilePic}
                      alt='image_user'
                      className='w-40-px h-40-px object-fit-cover rounded-circle'
                    />
                  </button>
                  <div className='dropdown-menu to-top dropdown-menu-sm'>
                    <div className='py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2'>
                      <div>
                        <h6 className='text-lg text-primary-light fw-semibold mb-2'>
                          Admin
                        </h6>
                      </div>
                      <button type='button' className='hover-text-danger'>
                        <Icon
                          icon='radix-icons:cross-1'
                          className='icon text-xl'
                        />
                      </button>
                    </div>
                    <ul className='to-top-list'>
                      {/* <li>
                        <Link
                          className='dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3'
                          to='/view-profile'
                        >
                          <Icon
                            icon='solar:user-linear'
                            className='icon text-xl'
                          />{" "}
                          My Profile
                        </Link>
                      </li> */}
                      {/* <li>
                        <Link
                          className='dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3'
                          to='/email'
                        >
                          <Icon
                            icon='tabler:message-check'
                            className='icon text-xl'
                          />{" "}
                          Inbox
                        </Link>
                      </li> */}
                      {/* <li>
                        <Link
                          className='dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3'
                          to='/company'
                        >
                          <Icon
                            icon='icon-park-outline:setting-two'
                            className='icon text-xl'
                          />
                          Setting
                        </Link>
                      </li> */}
                      <li>
                        <Link
                          className='dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-danger d-flex align-items-center gap-3'
                          to='/'
                          onClick={handleLogout}
                        >
                          <Icon icon='lucide:power' className='icon text-xl' />{" "}
                          Log Out
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* Profile dropdown end */}
              </div>
            </div>
          </div>
        </div>

        {/* dashboard-main-body */}
        <div className='dashboard-main-body'>{children}</div>

      </main>
    </section>
  );
};

export default MasterLayout;
